export const defaultError = 'error.defaultError';
/**
 * 로그인 에러 메시지
 */
// 로그인
export const BLANK_PHONE = 'BLANK_PHONE';
export const BLANK_STAFF_ID = 'BLANK_STAFF_ID';
export const BLANK_PASSWORD = 'BLANK_PASSWORD';

// 가입
export const BLANK_BUSINESS_NUMBER = 'BLANK_BUSINESS_NUMBER';
export const BLANK_CONFIRM_PASSWORD = 'BLANK_CONFIRM_PASSWORD';
export const BLANK_COMPANY_NAME = 'BLANK_COMPANY_NAME';
export const BLANK_MANAGER_NAME = 'BLANK_MANAGER  _NAME';
export const BLANK_MANAGER_PHONE = 'BLANK_MANAGER_PHONE';
export const WRONG_FORMAT_PHONE = 'WRONG_FORMAT_PHONE';
export const FALSE_AGREE_PRIVACY_USAGE = 'FALSE_AGREE_PRIVACY_USAGE';
export const IS_NOT_SAME_PASSWORD = 'IS_NOT_SAME_PASSWORD';
export const PHONE_EXISTS = 'PHONE_EXISTS';
export const PASSWORD_TOO_SHORT = 'PASSWORD_TOO_SHORT';
export const BUSINESS_NUMBER_NOT_VALID = 'BUSINESS_NUMBER_NOT_VALID';
export const BUSINESS_NUMBER_EXISTS = 'BUSINESS_NUMBER_EXISTS';
export const WRONG_FORMAT_BUSINESS_NUMBER = 'WRONG_FORMAT_BUSINESS_NUMBER';
export const WRONG_FORMAT_EMAIL = 'WRONG_FORMAT_EMAIL';
export const loginError = {
  // 클라이언트
  BLANK_PHONE: 'error.BLANK_PHONE',
  BLANK_STAFF_ID: 'error.BLANK_STAFF_ID',
  BLANK_PASSWORD: 'error.BLANK_PASSWORD',

  // 서버
  INVALID_STAFF_ID: 'error.COMMON_SIGN_IN',
  INVALID_PHONE_NUMBER: 'error.COMMON_SIGN_IN',
  INVALID_PASSWORD: 'error.COMMON_SIGN_IN',
  INACTIVE_STAFF_ID: 'error.INACTIVE_STAFF_ID',
};

export const joinError = {
  // 클라이언트
  BLANK_BUSINESS_NUMBER: 'error.BLANK_BUSINESS_NUMBER',
  BLANK_COMPANY_NAME: 'error.BLANK_COMPANY_NAME',
  BLANK_MANAGER_NAME: 'error.BLANK_MANAGER_NAME',
  BLANK_MANAGER_PHONE: 'error.BLANK_MANAGER_PHONE',
  WRONG_FORMAT_PHONE: 'error.WRONG_FORMAT_PHONE',
  BLANK_PASSWORD: 'error.BLANK_PASSWORD',
  BLANK_CONFIRM_PASSWORD: 'error.BLANK_CONFIRM_PASSWORD',
  FALSE_AGREE_PRIVACY_USAGE: 'error.FALSE_AGREE_PRIVACY_USAGE',
  IS_NOT_SAME_PASSWORD: 'error.password.notMatch',
  PASSWORD_TOO_SHORT: 'error.password.validate',
  BUSINESS_NUMBER_NOT_VALID: 'error.BUSINESS_NUMBER_NOT_VALID',
  BUSINESS_NUMBER_EXISTS: 'error.BUSINESS_NUMBER_EXISTS',
  WRONG_FORMAT_BUSINESS_NUMBER: 'error.WRONG_FORMAT_BUSINESS_NUMBER',
  WRONG_FORMAT_EMAIL: 'err.recruitment.email.2',
  // 서버
  PHONE_EXISTS: 'error.ALREADY_JOINED',
};

export const passwordError = {
  INVALID_PASSWORD: 'error.password.INVALID_PASSWORD',
};

export const workLogError = {
  INVALID_DATE: 'error.INVALID_DATE',
};

export const errorAlertMessage = err => {
  if (err === 'File too large') {
    // return '파일 크기가 최대 용량을 초과합니다.';
    return err;
  }
  if (typeof err?.response?.data?.errors?.message?.err === 'string') {
    return err.response.data.errors.message.err;
  }
  if (typeof err?.response?.data?.errors?.message === 'string') {
    return err.response.data.errors.message;
  }
  return 'Server Error';
  // return '서버통신에 실패했습니다.';
};
